// import { canUseDOM } from 'exenv';

export function afterbodyRecircModuleTypeLoading(resp = {}, store = {}) {
  return {
    type: 'POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADING',
    postAfterbodyRecircModule: resp,
    store
  };
}

export function afterbodyRecircModuleTypeLoaded(resp = {}, store = {}) {
  return {
    type: 'POST_AFTERBODY_RECIRC_MODULE_TYPE_LOADED',
    postAfterbodyRecircModule: resp,
    store
  };
}

export function afterbodyRecircModuleTypeLoadError(error, store = {}) {
  return {
    type: 'POST_AFTERBODY_RECIRC_MODULE_TYPE_ERROR',
    postAfterbodyRecircModule: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
